module.exports = __webpack_public_path__ + "static/media/vectorR.b2d4164a.svg";